import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PermissionService } from '../globalServices/permission.service';

/**
 * Guard that allows navigation only when the user is **not** authenticated.
 * Authenticated users are redirected to the default post‑auth landing page
 * (currently the dashboard). This guard is used for the public self‑registration
 * route so that logged‑in users cannot access it.
 */
export const unauthenticatedGuard: CanActivateFn = (): boolean => {
  const permissionService = inject(PermissionService);
  // Allow navigation only when NOT authenticated
  return !permissionService.isAuthenticated();
};
